import * as types from './mutations-type'

const mutations = {
    [types.FROMDAY] (state, payload) {
        state.fromDate.day = payload
    },
    [types.FROMMONTH] (state, payload) {
        state.fromDate.month = payload
    },
    [types.FROMYEAR] (state, payload) {
        state.fromDate.year = payload
    },

    [types.TODAY] (state, payload) {
        state.toDate.day = payload
    },
    [types.TOMONTH] (state, payload) {
        state.toDate.month = payload
    },
    [types.TOYEAR] (state, payload) {
        state.toDate.year = payload
    },

    [types.SHOWEMAILTYPEBLANK] (state, payload) {
        state.showEmailType.show_blank = payload
    },
    [types.SHOWEMAILTYPEUNUSED] (state, payload) {
        state.showEmailType.show_unused = payload
    },
    [types.SHOWEMAILTYPEUSED] (state, payload) {
        state.showEmailType.show_used = payload
    },
    [types.SHOWEMAILTYPEJUNK] (state, payload) {
        state.showEmailType.show_junk = payload
    },
    [types.SHOWEMAILTYPECOPY] (state, payload) {
        state.showEmailType.show_copy = payload
    },
    [types.HIDEMARKEDREAD] (state, payload) {
        state.hideMarkedRead = payload
    },
    [types.FLAG_C] (state, payload) {
        state.flags.c = payload
    },
    [types.FLAG_EN] (state, payload) {
        state.flags.en = payload
    },
    [types.FLAG_N] (state, payload) {
        state.flags.n = payload
    },
    [types.FLAG_RL] (state, payload) {
        state.flags.rl = payload
    },
    [types.FLAG_TC] (state, payload) {
        state.flags.tc = payload
    },
    [types.FLAG_TL] (state, payload) {
        state.flags.tl = payload
    },
    [types.FLAG_AE] (state, payload) {
        state.flags.ae = payload
    },
    [types.FLAG_PO] (state, payload) {
        state.flags.po = payload
    },
    [types.FLAG_HR] (state, payload) {
        state.flags.hr = payload
    },
    [types.FLAG_RE] (state, payload) {
        state.flags.re = payload
    },
    [types.FLAG_ID] (state, payload) {
        state.flags.id = payload
    },
    [types.FLAG_PT] (state, payload) {
        state.flags.pt = payload
    },
    [types.FLAG_PN] (state, payload) {
        state.flags.pn = payload
    },
    [types.PANELIST] (state, payload) {
        state.panelist = payload
    },
    [types.STATE] (state, payload) {
        state.state = payload
    },
    [types.COUNTRY] (state, payload) {
        state.country = payload
    },
    [types.BUSINESSOWENER] (state, payload) {
        state.businessOwner = payload
    },
    [types.PARTITION] (state, payload) {
        state.partition = payload
    },
    [types.ISFROMSEARCH] (state, payload) {
        state.isFromSearch = payload
    },
    [types.RESETSTATES] (state) {
        state.fromDate.day = ''
        state.fromDate.month = ''
        state.fromDate.year = ''
        state.toDate.day = ''
        state.toDate.month = ''
        state.toDate.year = ''
        state.showEmailType.show_blank = false
        state.showEmailType.show_unused = false
        state.showEmailType.show_used = false
        state.showEmailType.show_junk = false
        state.showEmailType.show_copy = false
        state.hideMarkedRead = false
        state.flags.c = false
        state.flags.en = false
        state.flags.n = false
        state.flags.rl = false
        state.flags.tc = false
        state.flags.tl = false
        state.flags.id = false
        state.flags.pt = false
        state.flags.pn = false
        state.flags.ae = false
        state.flags.po = false
        state.flags.hr = false
        state.flags.re = false
        state.panelist = ''
        state.state = ''
        state.country = ''
        state.businessOwner = ''
        state.partition = ''
        state.isFromSearch = false
        state.searchQuery = ''
        state.searchBy.id = false
        state.searchBy.subject = false
        state.searchBy.body = false
        state.searchBy.sender = false
    },
    [types.SEARCHQUERY](state, payload) {
        state.searchQuery = payload
    },
    [types.SEARCHBY](state, payload) {
        state.searchBy = payload
    },
    [types.SEARCHBYID](state, payload) {
        state.searchBy.id = payload
    },
    [types.SEARCHBYSUBJECT](state, payload) {
        state.searchBy.subject = payload
    },
    [types.SEARCHBYBODY](state, payload) {
        state.searchBy.body = payload
    },
    [types.SEARCHBYSENDER](state, payload) {
        state.searchBy.sender = payload
    },
    [types.PANELIST_TYPE](state, payload) {
        state.type_panelist = payload
    },
    [types.SEARCHBYSENDERNAME](state, payload) {
        state.searchBy.sender_name = payload
    },
    [types.SEARCHBYSENDEREMAIL](state, payload) {
        state.searchBy.sender_email = payload
    },

}

export default mutations